import React, { ReactElement } from 'react';
import dynamic from 'next/dynamic';
import RootLayout from 'layouts/RootLayout';
import proxyAxios from 'api/proxyAxios';
import { getMembersQuantity } from 'api/requests';
import { endpoints } from 'api/endpoints';
import { TopArticlesCardType } from 'sections/Home/types';
import { defaultMembersQuantity } from 'sections/Home/data';

const SectionHeader = dynamic(() => import('sections/Home/components/SectionHeader'));
const SectionAbout = dynamic(() => import('sections/Home/components/SectionAbout'));
const SectionVideo = dynamic(() => import('sections/Home/components/SectionVideo'));
const SectionBenefits = dynamic(() => import('sections/Home/components/SectionBenefits'));
const SectionFeatures = dynamic(() => import('sections/Home/components/SectionFeatures'));
const SectionCallToAction = dynamic(() => import('sections/Home/components/SectionCallToAction'));
const SectionTopArticles = dynamic(() => import('sections/Home/components/SectionTopArticles'));
const SectionSeoInfo = dynamic(() => import('sections/Home/components/SectionSeoInfo'));

interface IProps {
  membersQuantity: number | string;
  articles: TopArticlesCardType[];
}

export default function HomePage({ membersQuantity, articles }: IProps) {
  return (
    <div>
      <SectionHeader membersQuantity={membersQuantity} />
      <SectionAbout />
      <SectionVideo />
      <SectionBenefits />
      <SectionFeatures />
      <SectionCallToAction />
      <SectionTopArticles articles={articles} />
      <SectionSeoInfo />
    </div>
  );
}

export const getStaticProps = async () => {
  const HOUR = 60 * 60;
  const meta = {
    title: 'Global Freight Forwarder Network & NVOCCs Platform | DF Alliance',
    description: 'DF Alliance is the trusted network for freight forwarders and NVOCCs. Join our global network to grow your logistics business through strategic partnerships.',
    path: '/',
  };

  try {
    const data = await getMembersQuantity();

    const { data: articles } = await proxyAxios(endpoints.blog.previewArticles + '?limit=3');

    return { props: { membersQuantity: data.data.accounts, articles, ...meta }, revalidate: HOUR * 3 };
  } catch (e) {
    console.log('endpoints.membersQuantity', e);
  }

  return { props: { membersQuantity: defaultMembersQuantity, articles: [], ...meta }, revalidate: HOUR * 3 };
};

HomePage.getLayout = function getLayout(page: ReactElement) {
  return <RootLayout>{page}</RootLayout>;
};
